import { render } from "./Invoice_View.vue?vue&type=template&id=33c7a254"
import script from "./Invoice_View.vue?vue&type=script&lang=js"
export * from "./Invoice_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__